<template>
    <ModalComponent :isVisible="isVisible" @close="close" :width="width">
        <template #header>
            <div class="modal-header-container">
                <h2 class="modal-title">Tip of the Day</h2>
            </div>
        </template>
        <template #body>
            <div class="modal-body">
                {{ tipOfDay }}
            </div>
        </template>
        <template #footer>
            <button class="btn btn-secondary" @click="close">Close</button>
        </template>
    </ModalComponent>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import ModalComponent from '@/components/ModalComponent.vue'

defineProps({
    isVisible: Boolean,
    tipOfDay: String,
    width: String
})
const emit = defineEmits(['close'])
const close = () => {
    emit('close')
}
</script>

<style lang="scss" scoped>
.modal-header-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 5px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 10px;
}
.modal-title {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    margin-bottom: 5px; /* Space between title and subtitle */
}
</style>
